module.exports = __webpack_public_path__ + "img/cadeira_cinza.6217e313.png";